// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"d4b6453b","60":"c4b0d8b5","217":"a151e494","335":"1c5da93e","336":"65cad6f7","394":"471aa774","559":"52d1da49","692":"fdcab14d","725":"5365a311","746":"e5047f73"}[chunkId] + ".js";
};